import { Component, input } from '@angular/core';
import { CoreJssProxyModule } from '@core/jss-proxy';

import type { Hero } from '../models/hero.model';

@Component({
  selector: 'wl-hero-widget',
  standalone: true,
  imports: [CoreJssProxyModule],
  templateUrl: './hero-widget.component.html',
  styleUrls: [
    './hero-widget.component.ed.scss',
    './hero-widget.component.essent.scss',
  ],
})
export class HeroWidgetComponent {
  readonly hero = input.required<Hero>();
  readonly hasEssentRebranding = input<boolean>();
}
